module.exports = __webpack_public_path__ + "img/psbc.1c860105.jpg";